import { useState, useEffect, useRef } from 'react';
import api from '../services/api';

export function useWorkTimer() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const intervalRef = useRef(null);

  const fetchStatus = async () => {
    try {
      const res = await api.get('/time/status');
      setStatus(res.data);
    } catch {
      setStatus(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatus();
    intervalRef.current = setInterval(fetchStatus, 30000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const formatMinutes = (minutes) => {
    if (minutes == null) return '--:--';
    const sign = minutes < 0 ? '-' : '';
    const abs = Math.abs(minutes);
    const h = Math.floor(abs / 60).toString().padStart(2, '0');
    const m = (abs % 60).toString().padStart(2, '0');
    return `${sign}${h}:${m}`;
  };

  return { status, loading, refresh: fetchStatus, formatMinutes };
}
